/* eslint-disable @nx/enforce-module-boundaries */
// To do -> remove this and replace with axios
import { useBrokersServiceBrokersBrokersConfirmInviteCreate } from '@insurance/api/queries'
import {
  LOGIN_URL,
  messages,
  PASSWORD_PATTERN
} from '@organization/app-constants'
import {
  AuthWrapper,
  OrganizationLogo
} from '@organization/features/authentication/components'
import { useSearchParams } from '@organization/hooks'
import { showApiErrors } from '@shared/utils'
import { Alert, App, Button, Card, Flex, Form, Input } from 'antd'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { useStyle } from '../components/AuthWrapper/styles'

export const ConfirmBrokerInvitation = () => {
  const params = useSearchParams()
  const navigate = useNavigate()
  const [form] = Form.useForm()
  const { message } = App.useApp()
  const { styles } = useStyle()
  const { t } = useTranslation()

  const token = params.get('token')

  useEffect(() => {
    form.setFieldsValue({ token })
  }, [form, token])

  const { mutate, isPending } =
    useBrokersServiceBrokersBrokersConfirmInviteCreate({
      onSuccess: () => {
        message.success(messages.successRegistration)
        navigate(LOGIN_URL)
      },
      onError: (error) => showApiErrors(error, form)
    })

  const onSubmit = async () => {
    const values = await form.validateFields()

    mutate({
      requestBody: values
    })
  }

  return (
    <AuthWrapper>
      <Card className={styles.card}>
        <Flex vertical gap={16}>
          <OrganizationLogo
            message={(name) => `${t('auth.invitation_header')} ${name}`}
          />
          {!token && (
            <Alert
              type="error"
              message={t('error.invalid_invitation')}
              description={t('error.invitation_missing_token')}
              showIcon
            />
          )}
        </Flex>

        <Form
          form={form}
          layout="vertical"
          className={styles.form}
          requiredMark={false}
        >
          <Form.Item name="token" hidden>
            <Input autoComplete="off" />
          </Form.Item>

          <Form.Item
            label={t('form.item.password')}
            name="password"
            rules={[
              {
                pattern: PASSWORD_PATTERN,
                message: t('form.message.new_password_regex')
              },
              { required: true, message: t('form.message.password_required') }
            ]}
          >
            <Input.Password
              disabled={!token}
              autoComplete="off"
              placeholder={t('form.message.password')}
            />
          </Form.Item>

          <Form.Item
            label={t('form.item.confirm_password')}
            name="confirm_password"
            rules={[
              {
                pattern: PASSWORD_PATTERN,
                message: t('form.message.new_password_regex')
              },
              { required: true, message: t('form.message.confirm_password') },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('password') === value) {
                    return Promise.resolve()
                  }
                  return Promise.reject(new Error(t('error.password_no_match')))
                }
              })
            ]}
          >
            <Input.Password
              disabled={!token}
              autoComplete="off"
              placeholder={t('form.message.confirm_password')}
            />
          </Form.Item>

          <Button
            block
            type="primary"
            disabled={!token}
            htmlType="submit"
            loading={isPending}
            onClick={onSubmit}
          >
            {t('button.accept_invitation')}
          </Button>
        </Form>
      </Card>
    </AuthWrapper>
  )
}
